angular.module('Itao.HyperionAtlas').factory('BookmarkService', function($http, $httpParamSerializerJQLike, communeConfig){
  'use strict';
  var communeID = communeConfig.communeID;
  var userID = communeConfig.userID;
  var publishedVersion = communeConfig.published;
  var rootUri = jQuery('#communeUserData').data('root-uri');
  var ajaxTargetPid = 0;

  /**
   * Tries parsing a string as JSON
   * @param {String} value value containing possible JSON
   * @returns {Object|String}
   */
  function parseJSON(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

  /**
   * map a bookmark response to an internal bookmark object
   *
   * @param {Object} bookmark the bookmark response
   * @returns {{id: number, title: string, uri: string, category: number}}
   */
  function mapBookmark(bookmark) {
    return {
      id: bookmark.uid,
      title: bookmark.title,
      uri: generateBookmarkUri(bookmark.uid),
      category: bookmark.category,
      config: parseJSON(bookmark.config)
    };
  }

  /**
   * Returns a URL to the current atlas with the bookmark set to the given id
   *
   * @param {int} id the uid of the bookmark
   * @returns {string} the uri to the given bookmark
   */
  function generateBookmarkUri(id) {
    return window.location.protocol + '//' + window.location.host + window.location.pathname + '?tx_itaohyperion_pi0[action]=index&tx_itaohyperion_pi0[controller]=Atlas&tx_itaohyperion_pi0[bookmark]=' + id + '&tx_itaohyperion_pi0[selectedCommune]=' + communeID;
  }

  /**
   * map a bookmarkCategory response to an internal bookmarkCategory object
   *
   * @param {Object} bookmarkCategory the bookmarkCategory response
   * @returns {{id: number, title: string}}
   */
  function mapBookmarkCategory(bookmarkCategory) {
    return {
      id: bookmarkCategory.uid,
      title: bookmarkCategory.title
    };
  }

  return {
    createBookmark: function (title, categoryId, config) {

      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[bookmark]': {
            commune: communeID,
            user: userID,
            title: title,
            category: categoryId,
            config: JSON.stringify(config)
          }
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'createBookmark'
          }
        }).then(function(response){
          return mapBookmark(response.data);
        }, function(response){
          console.warn(response);
          return null;
        });
    },
    deleteBookmark: function(bookmark) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[uid]': bookmark
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'deleteBookmark'
          }
        });
    },
    getBookmarks: function() {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listBookmarks',
            'arguments[commune]': communeID,
            'arguments[showUnpublished]': publishedVersion ? '0' : '1' // only show unpublished bookmarks in internal atlas
          }
        }).then(function(response) {
          return response.data.map(mapBookmark);
        });
    },
    getAllBookmarks: function() {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoHyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listBookmarks',
            'arguments[commune]': communeID,
            'arguments[all]': true,
            'arguments[showUnpublished]': publishedVersion ? '0' : '1' // only show unpublished bookmarks in internal atlas
          }
        }).then(function(response) {
          return response.data.map(mapBookmark);
        });
    },
    getBookmarkCategories: function() {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listBookmarkCategories',
            'arguments[commune]': communeID
          }
        }).then(function(response) {
          return response.data.map(mapBookmarkCategory);
        });
    }
  };

});
